import { render, staticRenderFns } from "./FilterData.vue?vue&type=template&id=af945246"
import script from "./FilterData.vue?vue&type=script&lang=js"
export * from "./FilterData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports